import React from "react";
import { ProductRow, Table } from "../../settingInterface";
import { enableStock } from "../../../Home/ProductDisplay";
import { BarcodeCell } from "src/shared/configurations/commonPrint/barcodeCell/BarcodeCell";

export const productHeaderCell: Table<ProductRow>[] = [
    { id: "S.No", label: "S.No", numeric: false, sorting: false },
    { id: "Image", label: "Product Image", numeric: false, sorting: false },
    { id: "ProductName", label: "Products Name", numeric: false },
    { id: "ArabicName", label: "Other Name", numeric: false },
    { id: "barcodeId", label: "Barcode", numeric: false, sorting: false },
    { id: "category_name", label: "Category Type", numeric: false },
    { id: "PriceDetails", label: "Price Details (QR)", numeric: false, align: "left", sorting: false },
    { id: "Amount", label: "Final price(QR)", numeric: true, align: "left" },
    ...(enableStock ? ([{ id: "stock", label: "Stock /min-qty", numeric: true, align: "right" }] as const) : []),
];

export function calculateDiscountAmount(discount: string | number | undefined, price: number): number {
    if (!discount) return 0;
    const value = String(discount).trim();
    if (value.endsWith("%")) {
        const percent = parseFloat(value.replace("%", ""));
        return isNaN(percent) ? 0 : (price * percent) / 100;
    }
    const amount = parseFloat(value);
    return isNaN(amount) ? 0 : amount;
}

export function buildTableData(
    product: any[],
    page: number,
    rowsPerPage: number,
    amountFormat: (n: number) => string
): ProductRow[] {
    return product.map((item, index) => ({
        "S.No": page * rowsPerPage + index + 1,
        id: item._id.$oid,
        ProductName: item.productName,
        ArabicName: item.arabicName,
        category_name: item.categoryName || "",
        barcodeId: <BarcodeCell productId={item.barcodeId} />,
        PriceDetails: (
            <div className="flex flex-col text-sm text-gray-700">
                <div className="flex w-full justify-between">
                    <p>Purchase :</p>
                    <p>{amountFormat(Number(item.purchasePrice)) ?? 0.0}</p>
                </div>
                <div className="flex w-full justify-between">
                    <p>Selling :</p>
                    <p>{amountFormat(Number(item.sellingPrice)) ?? 0.0}</p>
                </div>
                <div className="flex w-full justify-between">
                    <p>Discount :</p>
                    <p>{calculateDiscountAmount(item.discount || "0", Number(item.sellingPrice) || 0)}</p>
                </div>
            </div>
        ),
        Amount: (
            <div className="flex flex-col text-sm text-gray-700">
                <div className="flex w-full justify-between">
                    <p>Retail :</p>
                    <p>{amountFormat(Number(item.amount)) ?? 0.0}</p>
                </div>
                <div className="flex w-full justify-between">
                    <p>Whole Sale :</p>
                    <p>{amountFormat(Number(item.wholeSalePrice)) ?? 0.0}</p>
                </div>
            </div>
        ),
        Image: item.imageUrl ?? "",
        stock: item.unitConfiguration.stock || 0,
    }));
}